import { render } from "./CometChatThreadedMessageReplyCount.vue?vue&type=template&id=b79a480e&scoped=true"
import script from "./CometChatThreadedMessageReplyCount.vue?vue&type=script&lang=js"
export * from "./CometChatThreadedMessageReplyCount.vue?vue&type=script&lang=js"

import "./CometChatThreadedMessageReplyCount.vue?vue&type=style&index=0&id=b79a480e&scoped=true&lang=css"

import exportComponent from "/Users/michael/Solileo Projects/Atout Organisation Science/Dossiers en cours/Keller Williams/Comet/vue3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b79a480e"]])

export default __exports__